export default "__VITE_ASSET__B8vFZRl8__"